"use strict";

module.exports = {
  dateString: require("./date-string")
};